import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import "./Facilitiessection.css";

const FacilitiesSection = ({ title, elements }) => {
  return (
    <section className="facilities-section">
      <h3>{title}</h3>
      <ul>
        {elements.map((element, index) => (
          <li key={index}>
            <FontAwesomeIcon icon={faCheckCircle} className="icon" />
            {element}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default FacilitiesSection;
